/**
 * Build popup menu
 * 
 * @param {Object} $ Cashdom object
 * @param {String} pfx Style prefix
 */
export default ($, pfx) => {
    const popup = $(`<div id="${pfx}popup">
        <div class="${pfx}popup-heading">
            <span>Block Settings</span>
            <span class="close">x</span>
        </div>
        <div class="${pfx}popup-body"></div>
        <div class="${pfx}popup-footer">
            <span id="${pfx}popup-footer-close" class="fa fa-times footer-red"></span>
            <span id="${pfx}popup-footer-undo" class="fa fa-undo footer-grey"></span>
            <span id="${pfx}popup-footer-redo" class="fa fa-repeat footer-grey"></span>
            <span id="${pfx}popup-footer-check" class="fa fa-check footer-green"></span>
        </div>
    </div>`);

    const popupBody = popup.find(`.${pfx}popup-body`);
    const tabLinks = $(`.${pfx}pn-panel.${pfx}pn-views`);
    const tabs = $(`.${pfx}pn-panel.${pfx}pn-views-container`);

    const openStyleBtn = $(`<div class="fa fa-cogs ${pfx}styles-btn"></div>`);
    openStyleBtn.on('click', e => popup.get(0).style.display = 'block');

    popup.find('.close').on('click', e => popup.get(0).style.display = 'none');
    popup.find(`#${pfx}popup-footer-close`).on('click', e => popup.get(0).style.display = 'none');
    popup.find(`#${pfx}popup-footer-undo`).on('click', e => editor.runCommand('core:undo'));
    popup.find(`#${pfx}popup-footer-redo`).on('click', e => editor.runCommand('core:redo'));
    popup.find(`#${pfx}popup-footer-check`).on('click', e => popup.get(0).style.display = 'none');

    popupBody.append(tabLinks);
    popupBody.append(tabs);

    return {
        popup,
        openStyleBtn
    };
}